module.exports = __webpack_public_path__ + "6cb6c6457f2f451aa2e99bd708692a24.pdf";